export const KbArticleTypeMap = {
  'wixui.Menu': 'editor-package-accessibility-wizard.articles-inaccessible-components-help.mega-menu',
  'wixui.SearchBox': 'editor-package-accessibility-wizard.articles-inaccessible-components-help.search-box',
  'wixui.StylableHorizontalMenu': 'editor-package-accessibility-wizard.articles-inaccessible-components-help.mega-menu',
  'wysiwyg.viewer.components.FormContainer': 'editor-package-accessibility-wizard.articles-inaccessible-components-help.old-form'
};
export const KbArticleTpaMap = [{
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.blog-tpa-widgets',
  name: 'MyDrafts',
  tpaId: '14f260e4-ea13-f861-b0ba-4577df99b961',
  type: 'wysiwyg.viewer.components.tpapps.TPAMultiSection'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.blog-tpa-widgets',
  name: 'MyPosts',
  tpaId: 'e5a2773b-0e6b-4cbb-a012-3b4a69e92046',
  type: 'wysiwyg.viewer.components.tpapps.TPAMultiSection'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.blog-tpa-widgets',
  name: 'BlogLikes',
  tpaId: '14f26109-514f-f9a8-9b3c-4d21861fe58f',
  type: 'wysiwyg.viewer.components.tpapps.TPAMultiSection'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.blog-tpa-widgets',
  name: 'BlogComments',
  tpaId: '14f260f9-c2eb-50e8-9b3c-4d21861fe58f',
  type: 'wysiwyg.viewer.components.tpapps.TPAMultiSection'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.blog-tpa-widgets',
  name: 'BlogPosts',
  tpaId: '14f26118-b65b-b1c1-b6db-34d5da9dd623',
  type: 'wysiwyg.viewer.components.tpapps.TPAMultiSection'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.post-page-on-blocks',
  name: 'PostPageOnBlocks',
  tpaId: '25ab36f9-f8bd-4799-a887-f10b6822fc2e',
  type: 'wysiwyg.viewer.components.RefComponent'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.bookings-tpa-widgets',
  name: 'StaffWidget',
  tpaId: '3dc66bc5-5354-4ce6-a436-bd8394c09b0e',
  type: 'wysiwyg.viewer.components.RefComponent'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.bookings-tpa-widgets',
  name: 'DailyTimeTable',
  tpaId: '89c4023a-027e-4d2a-b6b7-0b9d345b508d',
  type: 'wysiwyg.viewer.components.RefComponent'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.bookings-tpa-widgets',
  name: 'BookButton',
  tpaId: 'c7fddce1-ebf5-46b0-a309-7865384ba63f',
  type: 'platform.components.AppWidget'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.bookings-tpa-widgets',
  name: 'SingleService',
  tpaId: '14756c3d-f10a-45fc-4df1-808f22aabe80',
  type: 'wysiwyg.viewer.components.tpapps.TPAWidget'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.sound-cloud',
  name: 'SoundCloud',
  tpaId: '14a85b28-2374-72cf-db64-e0c11046aa60',
  type: 'wysiwyg.viewer.components.tpapps.TPAWidget'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.spotify-player',
  name: 'SpotifyPlayer',
  tpaId: '53d0a5fa-3da5-418b-84d6-e58bd55fecad',
  type: 'wysiwyg.viewer.components.tpapps.TPAWidget'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.bands-in-town',
  name: 'BandsInTown',
  tpaId: '1405f006-9eda-ce95-96c3-403f44d9e58a',
  type: 'wysiwyg.viewer.components.tpapps.TPAWidget'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.custom-member-pages',
  name: 'CustomLoginPage',
  tpaId: 'bbe1406a-31f5-4f3f-9e0a-b39dfd25274f',
  type: 'platform.components.AppWidget'
}, {
  articleKey: 'editor-package-accessibility-wizard.articles-inaccessible-components-help.custom-member-pages',
  name: 'CustomSignupPage',
  tpaId: '14ce1214-b278-a7e4-1373-00cebd1bef7c',
  type: 'platform.components.AppWidget'
}];
export const MAIN_KB_ARTICLE = 'editor-package-accessibility-wizard.articles-inaccessible-components-help';
//# sourceMappingURL=constants.js.map